import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { CLIENT_ROLES, ADMIN_ROLES } from "@/constants/roles";
import { resolveAppMode } from "@/utils/appMode";
import { redirectToSubdomainWithSession } from "@/utils/sessionHandoff";

function Spinner() {
  return (
    <div className="h-screen flex items-center justify-center bg-background">
      <div className="w-5 h-5 border-2 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

/** Protects /admin routes — blocks CLIENT_ROLES and redirects them to /app */
export function AdminGuard({ children }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  if (isLoading) return <Spinner />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (CLIENT_ROLES.includes(user.role)) {
    if (resolveAppMode().mode === "admin") {
      redirectToSubdomainWithSession("app");
      return <Spinner />;
    }
    return <Navigate to="/app" replace />;
  }
  return children;
}

/** Protects /app routes — blocks ADMIN_ROLES and redirects them to /admin */
export function ClientGuard({ children }) {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  if (isLoading) return <Spinner />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (ADMIN_ROLES.includes(user.role)) {
    if (resolveAppMode().mode === "client") {
      redirectToSubdomainWithSession("admin");
      return <Spinner />;
    }
    return <Navigate to="/admin" replace />;
  }
  return children;
}

/** Legacy alias — kept for any remaining usages */
export function AuthGuard({ children }) {
  return <AdminGuard>{children}</AdminGuard>;
}
